import React from 'react';
import html2canvas from 'html2canvas';
import { Button } from 'reactstrap';

export const DownloadBill = ({ currentOrder, totalAmount, customerName, totalDiscount }) => {
    const handleDownloadBill = () => {
        const billElement = document.getElementById('bill-content');
        
        html2canvas(billElement, {
          backgroundColor: 'white',
        //   scale: 2, 
          x: -20,  
          y: -20,  
          width: billElement.scrollWidth + 40,
          height: billElement.scrollHeight + 40,
        }).then((canvas) => {
          const link = document.createElement('a');
          link.download = `Bill-${customerName || 'Customer'}.jpg`;
          link.href = canvas.toDataURL('image/jpeg');
          link.click();
        });
      };
      

  return (
    <Button color="primary" onClick={handleDownloadBill}>
      Download Bill
    </Button>
  );
};